/**
 * @generated SignedSource<<81c62fe72408d03c70e5e8d68f5619c3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useCommentActionsWriteReactionsSummaryFragment$data = {
  readonly ari: string;
  readonly containerAri: string;
  readonly reactionsCount: number;
  readonly reactionsSummaryForEmoji: ReadonlyArray<{
    readonly count: number;
    readonly emojiId: string;
    readonly id: string;
    readonly reacted: boolean;
  } | null | undefined>;
  readonly " $fragmentType": "useCommentActionsWriteReactionsSummaryFragment";
};
export type useCommentActionsWriteReactionsSummaryFragment$key = {
  readonly " $data"?: useCommentActionsWriteReactionsSummaryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCommentActionsWriteReactionsSummaryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useCommentActionsWriteReactionsSummaryFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "reacted"
        }
      ]
    }
  ],
  "type": "ReactionsSummaryResponse"
};

(node as any).hash = "f6aafe0b5386657eb31d9d2871489adf";

export default node;
